export const isAxiosNetworkError = (error) =>
  Boolean(error?.request && !error?.response);

export const isNetworkErrorBreadcrumb = (breadcrumb) => {
  if (
    breadcrumb.category === 'console' &&
    breadcrumb.level === 'error' &&
    (breadcrumb.message?.includes('Network Error') ||
      breadcrumb.message?.includes('API ERROR:'))
  ) {
    return true;
  }

  if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
    return breadcrumb.data?.status_code === 0;
  }

  return false;
};
